<template>
  <div class="contact-outer">
    <CustomerServiceIcon
      height="1.5625rem"
      width="1.5625rem"
      :fill="props.type === 'arrotex' ? themeColors.colorArrotex : themeColors.colorVidacorp"
    />
    <div
      :style="{
        fontSize: props.fontSize,
        fontWeight: 600
      }"
    >
      {{ props.label }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useThemeStore } from '@/stores'
import CustomerServiceIcon from '../icons/CustomerServiceIcon.vue'

const themeStore = useThemeStore()
const { themeColors } = themeStore

interface IProps {
  label: string
  type?: string
  fontSize?: string
}

const props = withDefaults(defineProps<IProps>(), {
  fontSize: '1rem'
})
</script>

<style scoped>
.contact-outer {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.9375rem;
  border-radius: 3.125rem;
  border: 0.0625rem solid;
  gap: 0.625rem;
  cursor: pointer;
}

.arrotex {
  color: var(--color-arrotex-3);
}

.vidacorp {
  color: var(--color-vidacorp-3);
}
</style>
